// extracted by mini-css-extract-plugin
export default {"btn":"save_btn__llBpH"};